import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LabelQuestion, QuizLabelOption } from 'src/app/quiz/models/quiz-question.model';

@Component({
  selector: 'app-view-quiz-label-anatomy-answer',
  templateUrl: './view-quiz-label-anatomy-answer.component.html',
  styleUrls: ['./view-quiz-label-anatomy-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewQuizLabelAnatomyAnswerComponent implements OnInit {

  @Input()
  question: LabelQuestion;

  @Input()
  answer: string[];

  @Input()
  summary: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  isOptionAnswerCorrect(index: number) {
    const userAnswer = this.answer[index];
    const correctAnswer = this.question.data.correctAnswer[index];
    return userAnswer === correctAnswer;
  }

  getSelectedUserOption(index: number): QuizLabelOption {
    const userAnswer = this.answer[index];
    return this.question.data.options
      .find((option) => option.value === userAnswer);
  }

}
